import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import qs from 'query-string';

import getEnvConfig from 'utils/config/env';

import { IStatisticModeration } from './moderation.interface';
import { AnalyticsFiltersProps } from '../../AnalyticsFilters/service/filters.interface';

export const analyticsModerationApi = createApi({
    reducerPath: 'analyticsModeration',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['AnalyticsModeration'],
    endpoints: builder => ({
        getModeration: builder.query<
            IStatisticModeration,
            AnalyticsFiltersProps
        >({
            query: args => {
                const queryArgs = qs.stringify(args, {
                    arrayFormat: 'bracket-separator',
                    skipEmptyString: true,
                    skipNull: true,
                });
                return {
                    url: `/statistic/moderation/users?${queryArgs}`,
                    method: 'GET',
                };
            },
            transformResponse: (response: any) => {
                return response.data;
            },
        }),
    }),
});

export const { useLazyGetModerationQuery } = analyticsModerationApi;
